import {postCreateBonuses} from '../api/postCreateBonuses';

const setPostCreateBonuses = (params, setShowModal) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postCreateBonuses(params);

            if (data.status === 'success') {
                const id = data.data.id;  
                window.location.replace(window.location.origin + `/bonuses/settings/${params.label}/${id}`);
            }
        } catch(error) {
            setShowModal(true)
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCreateBonuses
}